import axios from "axios"

const actionGetProductionRecord = async ({commit}, payload) => {
  const result = await axios.get(`${process.env.VUE_APP_URL_API}/v1/reports/record_production`, {params:payload});
  commit("SET_PRODUCTION_RECORD", result.data.animals);
}
export default {
  actionGetProductionRecord
}
